<template>
  <div
    id="cadastro"
    @click.self="closeWindow"
  >
    <div id="double-section-layout">
      <section style="width: 100%">
        <button
          id="voltar"
          @click.prevent="closeWindow"
        >
          Fechar
        </button>
      </section>

      <section id="double-section-forms">
        <div class="form lado-esquerdo">
          <div class="listagem-central-coordenacao">
            <h4>Lista de membros da ação</h4>
            <div class="grid-tabela-cc cabecalho-container">
              <div class="coluna-cabecalho">Nome</div>
              <div class="coluna-cabecalho">Função</div>
              <div class="coluna-cabecalho">subtarefas</div>
              <div class="coluna-cabecalho">Horas trabalhadas</div>
              <div class="coluna-cabecalho">Informações</div>
            </div>

            <div class="itens-cc">
              <div
                class="itens-cc"
                v-for="membro in props.equipeAcao"
                :key="membro.id"
              >
                <div class="grid-tabela-cc item-cc">
                  <div class="celula-cc">{{ membro.nome }}</div>
                  <div class="celula-cc">{{ membro.funcaoMembro }}</div>
                  <div class="celula-cc">100</div>
                  <div class="celula-cc">10h</div>
                  <div class="celula-cc">
                    <button
                      type="button"
                      class="celula-cc btn-celula-cc"
                    >
                      Informações
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form lado-direito">
          <h4>Quadro de informações</h4>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  equipeAcao: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(["fecharTela"]);

function closeWindow() {
  emit("fecharTela");
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#cadastro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: hsla(0, 0%, 0%, 0.7); /* Fundo escuro semi-transparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: var(--roxo-medio);
  padding: 0;
  border-radius: 8px;
  max-width: 80%;
  max-height: 70vh;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 2rem;
}

.btn {
  position: absolute;
  top: 0;
  right: 0;
  color: var(--preto);
}

.quadro-informacoes {
  background-color: var(--roxo-primario);
  max-width: 90%;
  width: 50%;
  border: 1px groove var(--preto);
  border-radius: 10px;
}

.quadro-informacoes > h4 {
  text-align: center;
}

.tabela {
  max-width: 90%;
  border: 1px solid var(--cinza-claro);
  border-radius: 8px;
  padding: 16px;
  background: var(--roxo-medio);
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  color: var(--preto);
}

.tabela > h4 {
  text-align: center;
  color: var(--cinza-claro);
}

.grid-tabela {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 7px;
}

.cabecalho-container {
  flex-shrink: 0;
  color: var(--cinza-claro);
}

.cabecalho {
  font-weight: bold;
  padding: 7px;
  text-align: center;
  background-color: var(--roxo-primario);
  border-radius: 0px 0px 10px;
  font-size: 1rem;
}

.tarefas-container {
  overflow-y: auto;
  max-height: 500px;
  margin-top: 10px;
  flex-grow: 1;
  scrollbar-width: thin;
  scrollbar-color: var(--roxo-primario) var(--roxo-medio);
}

.tarefa-container {
  margin-bottom: 5px;
  flex-shrink: 0;
}

.linha-tarefa {
  background-color: hsla(0, 0%, 100%, 0.1);
  border-radius: 4px;
}

.celula {
  border-bottom: 1px groove var(--preto);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  margin-bottom: 4px;
  font-size: 0.92rem;
  max-width: 100%;
  padding: 5px;
  word-break: normal;
}

.btn-informacoes {
  padding: 7px;
  font-size: 1rem;
  background-color: var(--roxo-primario);
  color: var(--cinza-claro);
  border-radius: 10px 0px 10px;
}

.btn-informacoes:hover {
  border: 1px groove var(--preto);
}

.tarefas-container::-webkit-scrollbar {
  width: 8px;
}

.tarefas-container::-webkit-scrollbar-track {
  background: var(--roxo-medio);
  border-radius: 10px;
}

.tarefas-container::-webkit-scrollbar-thumb {
  background-color: var(--roxo-primario);
  border-radius: 10px;
}

.form {
  margin: 0;
}

@media (max-width: 768px) {
  #double-section-forms {
    flex-direction: column;
    overflow-y: auto;
  }

  .lado-esquerdo,
  .lado-direito,
  .form.lado-esquerdo,
  .form.lado-direito {
    width: 100%;
    max-width: 100%;
  }

  .listagem-central-coordenacao {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }

  .grid-tabela-cc {
    min-width: 480px;
  }
}
</style>
